<template>
  <div id="file-drag-drop">
    <font-awesome-icon id='spinner' v-if="isSaving" :icon="['fas', 'spinner']" size="4x" spin />
    <form v-else ref="fileform" class="upload-file">
      <input type="file"  accept="image/x-png,image/png,image/jpeg" id="file" @change="onChange" ref="myFiles" class="custom-file-input" multiple> Click here to Browse in your computer<br>or<br>Drag and drop or select your free license photo(s)
    </form>
    <button style="position: relative;" type="button" class="btn btn-md btn-secondary mt-3 mb-3" :disabled="isSaving"  v-on:click="submitFiles()" v-show="files.length > 0">
      <font-awesome-icon :icon="['fas', 'plus-circle']" v-if="!isSaving" />
      <font-awesome-icon v-else class="text-white" :icon="['fas', 'spinner']" spin />
      Save Upload
    </button>
    <span class="error" v-if="error">Please fill the required fields: Country and city.</span>
    <progress max="100" :value.prop="uploadPercentage" v-if="uploadPercentage>0"></progress>
    <div v-for="(file, key) in files" :key="key" class="file-listing">
      <img class="preview" v-bind:ref="'preview'+parseInt(key)"/>
      {{ file.name }}
      <div class="remove-container">
        <a class="remove" v-on:click="removeFile(key)">Remove</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageUploader',
  data () {
    return {
      dragAndDropCapable: false,
      files: [],
      isSaving: false,
      uploadPercentage: 0,
      error: false,
      country: this.paramsSelected.country || '',
      city: this.paramsSelected.city || ''
    }
  },
  props: {
    isSearching: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    defaultParams: {
      type: Object,
      required: false
    },
    paramsSelected: {
      type: Object,
      required: false
    }
  },
  methods: {
    determineDragAndDropCapable () {
      var div = document.createElement('div')
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
    },
    getImagePreviews () {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png)$/i.test(this.files[i].name)) {
          const RATIO = 1024 * 1024 // 1024 Bytes * 1024 === 1048576 Bytes === 1 MB
          const MIN_SIZE = 1
          const MAX_SIZE = 20
          const MIN_FILE_SIZE = RATIO * MIN_SIZE // 1048576 Bytes === 1 MB
          const MAX_FILE_SIZE = RATIO * MAX_SIZE // 20971520 Bytes === 20 MB
          if ((this.files[i].size >= MIN_FILE_SIZE) && (this.files[i].size <= MAX_FILE_SIZE)) {
            let reader = new FileReader()
            reader.addEventListener('load', function () {
              this.$refs['preview' + parseInt(i)][0].src = reader.result
            }.bind(this), false)
            reader.readAsDataURL(this.files[i])
          } else {
            this.$notification.error(`Please upload an image upper than ${MIN_SIZE}MB and lower than ${MAX_SIZE}MB (${this.files[i].name}).`, 14000)
            this.removeFile(i)
            i = i - 1
          }
        } else {
          this.$notification.error('Wrong file extension!, you only can upload JPEG, JPG, PNG images')
          this.removeFile(i)
          i = i - 1
        }
      }
    },
    removeFile (key) {
      this.files.splice(key, 1)
    },
    formatFileName(text) {
      return text.replace(/[&/\\#,;+()$~%.'":*?<>{}]/g, "_");
    },
    submitFiles () {
      this.isSaving = true
      let total = this.files.length
      let aux = 0
      this.uploadPercentage = 1
      this.country = this.paramsSelected.country
      this.city = this.paramsSelected.city
      let country = this.country.value
      let city = this.city.value
      if (!this.validParams({ country, city })) {
        return this.cancelSubmitFiles()
      }
      for (let i = 0; i < total; i++) {
        let file = this.files[i]
        let base64 = this.getBase64(file)
        base64.onload = function () {
          let fileTransformed = base64.result.split(',')
          let filename = this.formatFileName(file.name).split('.')
          let name = country + '/' + city + '/' + filename[0]
          let formData = {
            name: name,
            data: fileTransformed[1]
          }
          this.$store.dispatch('asset/uploadAsset', formData)
            .then((response) => {
              if (!response.data.success) {
                this.$notification.warning(response.data.msg, 10000)
                this.error = false
                this.isSaving = false
                return false
              }
              if (this.data.length >= 21) {
                this.data.pop()
              }
              response.data.asset[0].thumbnail = response.data.asset[0].url
              this.data.unshift(response.data.asset[0])
              aux++
              this.uploadPercentage = parseInt((aux / total) * 100)
              if (aux === total) {
                this.uploadPercentage = 100
                this.loadDefault()
              }
            })
            .catch(error => {
              aux++
              console.log('Error on upload image named: ' + this.formatFileName(file.name) + ', Error: ' + error)
            })
        }.bind(this)
        base64.onerror = function (error) {
          aux++
          this.$notification.error('Error on convert image named: ' + this.formatFileName(file.name))
          console.log('Error:', error)
        }
      }
    },
    validParams (params) {
      return params.country && params.city
    },
    cancelSubmitFiles () {
      this.error = true
      this.isSaving = false
      setTimeout(() => {
        this.error = false
      }, 5000)
      return false
    },
    getBase64 (file) {
      var reader = new FileReader()
      reader.readAsDataURL(file)
      return reader
    },
    toggleView () {
      this.$parent.uploading = !this.$parent.uploading
    },
    loadDefault () {
      this.isSaving = false
      this.files = []
      this.toggleView()
      this.$notification.success('All images were uploaded!')
      setTimeout(() => {
        this.uploadPercentage = 0
      }, 200)
    },
    loadFiles (e) {
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        for (let f = 0; f < this.files.length; f++) {
          if (this.files[f].name === e.dataTransfer.files[i].name) {
            this.files.splice(f, 1)
          }
        }
        this.files.push(e.dataTransfer.files[i])
      }
      this.getImagePreviews()
    },
    onChange (e) {
      for (let i = 0; i < e.target.files.length; i++) {
        for (let f = 0; f < this.files.length; f++) {
          if (this.files[f].name === e.target.files[i].name) {
            this.files.splice(f, 1)
          }
        }
        this.files.push(e.target.files[i])
      }
      this.getImagePreviews()
    }
  },
  mounted () {
    this.dragAndDropCapable = this.determineDragAndDropCapable()
    if (this.dragAndDropCapable) {
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileform.addEventListener(evt, function (e) {
          e.preventDefault()
          e.stopPropagation()
        }, false)
      }.bind(this))

      this.$refs.fileform.addEventListener('drop', function (e) {
        this.loadFiles(e)
      }.bind(this))
    }
  },
  watch: {
    data (newValue, oldValue) {
      this.data = newValue
    },
    paramsSelected: {
      deep: true,
      inmediate: true,
      handler (newValue, oldValue) {
        this.city = newValue.city
      }
    }
  }
}
</script>

<style>
form.upload-file {
  display: block;
  height: 200px;
  background: #f0f3f8;
  border-radius: 4px;
  color: #666666 !important;
  font-size: 1.4rem;
  font-weight: 500;
  text-align: center;
  padding-top: 60px;
}

div.file-listing{
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

div.file-listing img{
  height: 50px;
}

div.remove-container{
  text-align: center;
}

div.remove-container a{
  color: red;
  cursor: pointer;
}
div.loader {
  width: 100%;
  margin: 100px 50%;
}

#spinner{
  width: 100%;
}

progress{
  width: 100%;
  margin: auto;
  display: block;
  margin-top: 10px;
  margin-bottom: 50px;
}

#file {
  position: absolute;
  height: 140px;
  left: 0;
}

.error {
  color: red;
  margin: 5px 10px;
}
</style>
